import { MAP_LOGO_BY_PROVIDER } from '../../../../../../components/__common/map-logo-by-provider'
import { Plugin } from 'chart.js'
import { ProviderName } from '@indigohive/cogfy-providers'

const array = [new Image(), new Image(), new Image(), new Image()]

export const barAvatarPlugin: Plugin<'bar'> = {
  id: 'barAvatarPlugin',
  afterDatasetDraw: (chart) => {
    const { ctx } = chart
    const meta = chart.getDatasetMeta(0)

    chart.data.labels?.forEach((name, index) => {
      const img = array[index]
      if (!img) return
      const { x, y } = meta.data[index]

      const logoSrc = MAP_LOGO_BY_PROVIDER[name as ProviderName]
      if (!logoSrc) return

      img.src = logoSrc

      const imgWidth = 26
      const imgHeight = 26
      const cornerRadius = 6
      const imgX = x - imgWidth / 2
      const imgY = y - imgHeight - 10

      // Salva o estado atual
      ctx.save()

      // Cria path quadrado arredondado para clipping
      ctx.beginPath()
      ctx.moveTo(imgX + cornerRadius, imgY)
      ctx.lineTo(imgX + imgWidth - cornerRadius, imgY)
      ctx.quadraticCurveTo(imgX + imgWidth, imgY, imgX + imgWidth, imgY + cornerRadius)
      ctx.lineTo(imgX + imgWidth, imgY + imgHeight - cornerRadius)
      ctx.quadraticCurveTo(imgX + imgWidth, imgY + imgHeight, imgX + imgWidth - cornerRadius, imgY + imgHeight)
      ctx.lineTo(imgX + cornerRadius, imgY + imgHeight)
      ctx.quadraticCurveTo(imgX, imgY + imgHeight, imgX, imgY + imgHeight - cornerRadius)
      ctx.lineTo(imgX, imgY + cornerRadius)
      ctx.quadraticCurveTo(imgX, imgY, imgX + cornerRadius, imgY)
      ctx.closePath()
      ctx.clip()

      ctx.drawImage(img, imgX, imgY, imgWidth, imgHeight)

      // Restaura o estado original
      ctx.restore()
    })
  }
}
